import styled from 'styled-components';

export const SketchPickerContainer = styled.div`
  height: 366px;
  .sketch-picker {
    height: 352px;
  }
`;

export const EyeDropperContainer = styled.div`
  float: right;
  position: relative;
  top: -80px;
  right: 10px;

  > .anticon {
    > #color-picker {
      position: initial !important;
      width: 20px !important;
      height: 18px !important;
      top: initial;
      left: initial;
    }
  }
`;

export const CMYKColorSelector = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  font-size: 11px;
  color: rgb(34, 34, 34);
  .ant-input-number {
    border: none;
    height: 26px;
  }
  input {
    padding: 4px 10% 3px;
    border: none;
    box-shadow: rgb(204, 204, 204) 0px 0px 0px 1px inset;
    font-size: 11px !important;
    font-weight: 100 !important;
    width: 96%;
    border-radius: unset;
    height: 24px;
  }
  .ant-input-number-handler-wrap {
    display: none;
  }
`;

export const CMYKColorContainer = styled.span`
  display: flex;
  font-size: inherit;
  text-align: center;
  position: relative;
  top: -50px;
  left: 10px;
  input {
    text-align: center;
  }

`;
